<template>
  <div>
    <p>{{ intro }}</p>
    <ul>
      <li
        v-for="item in items"
        :key="item.term"
      >
        <span
          ><strong>{{ item.term }}</strong></span
        >
        <span> - {{ item.description }}</span>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  intro: string;
  items: Array<{ term: string; description: string }>;
}>();
</script>
